module.exports = "/_next/static/images/Hero@2x-63097beec02b75e7ed859cac77c929c3.png";